import { ApiResponse } from 'apisauce';
import { CompactAvailability } from '../../../modules/products/ProductTypes';
import { PaginatedResponse } from '../../../types/request.types';
import { cancelTokenFromSignal } from '../../../utils/axios.utils';
import { restApi } from '../../api';
import { PaginatedEndpointParams } from '../../types';
import {
  FindProductColorPacksToOfflineOutput,
  PageSelectedPacksOutput,
  PageSelectedPacksParams,
  ProductColorWithPacks,
  ProductColorWithPacksOutput,
  UpdateBlockPartialApplicationParams,
} from './product-colors-packs.types';

const PATH = 'product-colors';

export const attachPackToProductColor = async (
  productColorId: string,
  packId: string,
  productColorPackType: CompactAvailability,
): Promise<ApiResponse<ProductColorWithPacksOutput>> =>
  restApi.post<ProductColorWithPacksOutput>(`${PATH}/${productColorId}/packs/${packId}`, {
    type: productColorPackType,
  });

export const detachPackFromProductColor = async (
  productColorId: string,
  productColorPackId: string,
): Promise<ApiResponse<ProductColorWithPacksOutput>> =>
  restApi.delete<ProductColorWithPacksOutput>(
    `${PATH}/${productColorId}/packs/${productColorPackId}`,
  );

export const updateBlockPartialApplication = async ({
  type,
  productColorId,
  allowPartialApply,
}: UpdateBlockPartialApplicationParams) =>
  restApi.patch(`${PATH}/${productColorId}/allow-partial-apply-flag`, {
    type,
    allowPartialApply,
  });

export const pageSelectedPacks = async ({
  productColorAvailability,
  productColorId,
  ...params
}: PageSelectedPacksParams) =>
  restApi.get<PageSelectedPacksOutput>(
    `${PATH}/${productColorId}/selected-packs/${productColorAvailability}`,
    params,
  );

export const findProductColorPacksToOffline = async (productColorIds: string[]) =>
  restApi.get<FindProductColorPacksToOfflineOutput>(`${PATH}/packs/offline/v1`, {
    productColorIds,
  });

export const findProductColorsWithPacks = (
  productId: string,
  params: PaginatedEndpointParams,
  signal?: AbortSignal,
) =>
  restApi.get<PaginatedResponse<ProductColorWithPacks>>(`products/${productId}/packs`, params, {
    cancelToken: cancelTokenFromSignal(signal)?.token,
  });
